/*************************************************/
/* Server rendered list                          */
/*************************************************/
/* The full employee list is rendered server side so crawlers see every employee. This reveals it
   in batches, and steps aside as soon as the Vue app reports that a filter is in play. */

const hiddenCardClass = "employee-card--hidden";
const hiddenClass = "is-hidden";
const serverListEvent = "employeesFilterStateChanged";
const serverList = document.querySelector("[data-employees-server-list]");

if (serverList) {
    const loadMoreButton = serverList.querySelector("[data-employees-server-load-more]");
    const batchSize = parseInt(serverList.dataset.batchSize, 10) || 16;

    const updateLoadMoreButton = () => {
        if (loadMoreButton) {
            loadMoreButton.classList.toggle(
                hiddenClass, serverList.getElementsByClassName(hiddenCardClass).length === 0);
        }
    };

    if (loadMoreButton) {
        loadMoreButton.addEventListener("click", (event) => {
            event.preventDefault();
            // Live collection, so take a copy before mutating the class that defines it.
            const hiddenCards = Array.prototype.slice.call(
                serverList.getElementsByClassName(hiddenCardClass), 0, batchSize);

            hiddenCards.forEach((card) => card.classList.remove(hiddenCardClass));
            updateLoadMoreButton();
        });
    }

    updateLoadMoreButton();

    window.addEventListener(serverListEvent, (event) => {
        serverList.classList.toggle(hiddenClass, event.detail === true);
    });
}

/*************************************************/
/* Vue                                           */
/*************************************************/
import { createApp,h } from 'vue';
import {createRouter,createWebHistory} from "vue-router";
import Employees from './vue/employees.vue';

const employeesAppElement = document.querySelector("#employeesApp");
if (employeesAppElement) {
    const employeesNodeId = employeesAppElement.dataset.employeesNodeId;
    const preselectedLocationNodeId = employeesAppElement.dataset.preselectedLocationNodeId;

    const router = createRouter({
        history: createWebHistory(),
        routes: [{path : window.location.pathname,component:Employees}]
    });

    const seedData = {employeesNodeId:employeesNodeId,preselectedLocationNodeId:preselectedLocationNodeId};

    const employeesApp = createApp({
        data() {return seedData},
        render: ()=>h(Employees)
    },seedData);

    employeesApp.use(router);
    router.isReady().then(() => employeesApp.mount(employeesAppElement));
}
